export default [
  {
    path: "/call",
    name: "call",
    component: () => import("@/views/callList/Call.vue"),
    meta: {
      resource: "call",
      action: "read",
      title: "breadcrumb.call",
      contentRenderer: "sidebar-left",
      contentClass: "chat-application",
    },
  },
];
